import React, { useState, useEffect, useContext } from "react";
import AlertaContext from "../../context/alertas/alertaContext";
import CitasContext from "../../context/citas/citasContext";
import AuthContext from "../../context/autenticacion/authContext";
import TopBar from "../layout/TopBar";
// import Barra from '../layout/Barra';
import AsyncSelect from "react-select/lib/Async";

const Citas = (props) => {
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;

  const authContext = useContext(AuthContext);
  const { usuarioAPIAutenticado } = authContext;

  const citasContext = useContext(CitasContext);
  const {
    citas,
    obtenerSucursales,
    obtenerEstudios,
    guardarCita,
    obtenerCitas,
  } = citasContext;

  const today = new Date();
  const date = new Date(today);
  date.setDate(date.getDate());

  var min = `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? "0" : ""}${
    date.getMonth() + 1
  }-${date.getDate() < 10 ? "0" : ""}${date.getDate()}`;

  const [registroCita, setRegistroCita] = useState({
    sucursal: null,
    fecha: "",
    estudio: null,
    pacienteId: props.location.state ? props.location.state.pacienteId : null,
    pacienteNombre: props.location.state
      ? props.location.state.pacienteNombre
      : null,
    doctorId: props.location.state ? props.location.state.doctorId : null,
  });

  const { sucursal, fecha, estudio, pacienteId, pacienteNombre, doctorId } =
    registroCita;

  useEffect(() => {
    usuarioAPIAutenticado(1);

    obtenerCitas(
      props.location.state
        ? props.location.state.pacienteId
        : JSON.parse(localStorage.getItem("usuario")).entidadId
    );
    /*if( !citas ){
            obtenerCitas( 
                props.location.state ? props.location.state.pacienteId 
                :
                JSON.parse( localStorage.getItem( 'usuario' ) ).entidadId );
        }*/

    //eslint-disable-next-line
  }, []);

  const cargarSucursales = async (search) => {
    let filtro = search.length > 0 ? search : "all";
    let data = obtenerSucursales(filtro);

    return data;
  };

  const cargarEstudios = async (search) => {
    let filtro = search.length > 0 ? search : "all";
    let data = obtenerEstudios(filtro);

    return data;
  };

  const onChangeSucursal = (e) => {
    setRegistroCita({
      ...registroCita,
      sucursal: e,
    });
  };

  const onChange = (e) => {
    setRegistroCita({
      ...registroCita,
      fecha: e.target.value,
    });
  };

  const onChangeEstudio = (e) => {
    setRegistroCita({
      ...registroCita,
      estudio: e,
    });
  };

  const formatDate = (date) => {
    let fechaHora = date.split(" ");

    let fecha = fechaHora[0].split("-");

    let format =
      fechaHora.length > 1
        ? `${fecha[2]}/${fecha[1]}/${fecha[0]} ${fechaHora[1]} ${fechaHora[2]}`
        : `${fecha[2]}/${fecha[1]}/${fecha[0]}`;

    return format;
  };

  const limpiarForm = () => {
    setRegistroCita({
      ...registroCita,
      sucursal: null,
      fecha: "",
      estudio: null,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!sucursal) {
      mostrarAlerta("Es necesario seleccionar la sucursal", "alert-danger");
      return;
    }

    if (!fecha) {
      mostrarAlerta(
        "Es necesario seleccionar la fecha de su cita",
        "alert-danger"
      );
      return;
    }

    if (!estudio) {
      mostrarAlerta(
        "Es necesario seleccionar al menos un estudio para poder registrar su cita",
        "alert-danger"
      );
      return;
    }

    let idContacto = pacienteId
      ? pacienteId
      : JSON.parse(localStorage.getItem("usuario")).entidadId;

    let data = {
      encabezado: {
        sucursalId: sucursal.value,
        almacenId: sucursal.almacenId,
        divisionId: 30000,
        centroCostoId: 5,
        conceptoId: estudio[0].value,
        fecha: formatDate(fecha),
        fecha_hora: formatDate(`${fecha} 7:00 AM`),
        contactoId: idContacto,
        doctorId: doctorId ? doctorId : 0,
        subtotal: 0.0,
        descuento: 0.0,
        impuesto1: 0.0,
        total: 0.0,
        comentario: "",
      },
      partidas: estudio.map((e) => ({
        sucursalId: sucursal.value,
        almacenId: sucursal.almacenId,
        divisionId: 30000,
        centroCostoId: 5,
        conceptoId: e.value,
        umId: 0,
        cantidad: 1,
        precioUnitario: 0.0,
        impuestoId1: 8001,
        descuento: 0.0,
        subtotal: 0.0,
        impuesto1: 0.0,
        total: 0.0,
        comentario: "",
      })),
    };

    guardarCita(data);
    limpiarForm();
  };

  return (
    <div>
      <TopBar />
      <div className="container">
        {/* <Barra /> */}
        {alerta ? (
          <div
            className={`alert ${alerta.categoria} alert-dismissible fade in`}
          >
            {" "}
            {alerta.msg}{" "}
          </div>
        ) : null}
        <div className="row">
          <div className="col-sm text-center">
            <div className="card d-flex">
              <form className="form-signin" onSubmit={onSubmit}>
                <img
                  className="mb-4 img-fluid"
                  src="img/logo-limed.png"
                  alt="limed"
                  height="60"
                />
                <h1 className="my20">Registra tu cita</h1>
                {pacienteNombre ? (
                  <div className="form-group text-left">
                    <label htmlFor="paciente">Paciente</label>
                    <p id="paciente">{pacienteNombre}</p>
                  </div>
                ) : null}
                <div className="form-group text-left">
                  <label htmlFor="sucursal">Sucursal</label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    loadOptions={cargarSucursales}
                    onChange={onChangeSucursal}
                    value={sucursal}
                    placeholder="Seleccione sucursal..."
                  />
                </div>
                <div className="form-group text-left">
                  <label htmlFor="fecha">Fecha</label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    min={min}
                    onChange={onChange}
                    value={fecha}
                    className="form-control"
                  />
                </div>
                <div className="form-group text-left">
                  <label htmlFor="estudio">Estudio</label>
                  <AsyncSelect
                    isMulti
                    cacheOptions
                    defaultOptions
                    loadOptions={cargarEstudios}
                    onChange={onChangeEstudio}
                    value={estudio}
                    placeholder="Seleccione estudio..."
                  />
                </div>
                <button
                  className="btn btn-lg btn-primary btn-block"
                  type="submit"
                >
                  <i className="bi bi-check-lg"></i>
                  Registrar
                </button>
              </form>
            </div>
          </div>
          <div className="col-sm-4">
            <div
              className="card d-flex h100"
              style={{
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                position: "absolute",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <h4 className="card-title text-center">Próximas citas</h4>
              {!citas || citas.length < 1 ? (
                <p className="text-center">No hay citas programadas</p>
              ) : (
                <div className="timeline">
                  {citas.map((c, index) => (
                    <div
                      key={index}
                      className="containertimeline right d-flex flex-column"
                    >
                      <div className="content">
                        <h4>{c.fecha_hora}</h4>
                        <p>
                          {`Folio: ${c.folio}`}
                          <br />
                          {`Sucursal ${c.sucursal}`}
                          <br />
                          {`Estudios: ${c.estudios}`}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Citas;
